import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "components/app/dialog/dialog";

import { ScrollArea } from "components/ui/scroll-area";
import { Service } from "utils/services";

import { useEffect, useState } from "react";
import { RequestApi, RouteApi, RouteUrl, StatusMsg } from "utils";
import { useAppSelector } from "store/store";

import { Loader, Minus, Plus, X } from "lucide-react";
import DatePicker from "components/app/function/DatePicker";
import NumberInput from "components/app/function/NumberInput";
import TextInput from "components/app/function/TextInput";
import SelectGroupRadioOptionSingle from "components/app/function/SelectOneRadioOption";
import appStore from "store/appStore";
import SwitchYesNo from "components/app/function/SwitchYesNo";
import { ShimmerCampaingsDetail } from "components/app/shrimmer/Shrimmer";
import { useNavigate } from "react-router-dom";
import { AppLog } from "services";

import { noneProfile } from "assets";
import { PostReaction } from "models/postReaction";
import DialogPostReaction from "components/app/dialog/DialogPostReaction";

interface DialogProps {
  isDailogDetailCampaing: boolean;
  onValueChange: ({ id, valuse, name }: { id: number; valuse: string; name: string }) => void;
  campaingsDetailLoading: boolean;
  campaingsDetail: any;
  setIsDailogDetailCampaings: (value: boolean) => void;
}
export default function DailogDetailCampaings({ isDailogDetailCampaing, setIsDailogDetailCampaings, campaingsDetail, onValueChange, campaingsDetailLoading }: DialogProps) {
  const postContents = (post: any) => {
    if (post?.media_type?.toLowerCase() === "photo" || post?.media_type?.toLowerCase() === "album") {
      const width = Service.toDouble(post?.post_attachments[0].attachment_media_width);
      const height = Service.toDouble(post?.post_attachments[0].attachment_media_height);
      const ratio = height === 0 ? 1 : width / height;

      return (
        <div className="flex w-full h-full relative overflow-hidden  pointer-events-none rounded-lg  ">
          <div
            className="absolute inset-0 bg-cover bg-center bg-black opacity-50 blur-3xl  "
            style={{
              backgroundImage: `url("${post?.post_attachments[0]?.attachment_thumbnail_image_file_src}")`,
            }}
          />
          <img
            // onClick={() => onGoToPost(post.provider_post_id)}
            style={{ cursor: "pointer" }}
            src={post?.post_attachments[0].attachment_media_image_file_src}
            alt="Post"
            className={`relative z-10  w-full h-auto rounded-lg    ${ratio >= 0 && ratio < 0.74 ? "object-cover rounded-lg" : "object-contain rounded-lg"}`}
            loading="lazy"
          />
        </div>
      );
    } else if (post?.media_type?.toLowerCase() === "video") {
      const width = Service.toDouble(post?.post_attachments[0].attachment_media_width);
      const height = Service.toDouble(post?.post_attachments[0].attachment_media_height);
      const ratio = height === 0 ? 1 : width / height;

      return (
        <div className="flex w-full h-full relative overflow-hidden  pointer-events-none rounded-lg ">
          <div
            className="absolute inset-0 bg-cover bg-center bg-black opacity-50 blur-3xl  "
            style={{
              backgroundImage: `url("${post?.post_attachments[0]?.attachment_thumbnail_image_file_src}")`,
            }}
          />

          <img
            // onClick={() => onGoToPost(post.provider_post_id)}
            style={{ cursor: "pointer" }}
            src={post?.post_attachments[0].attachment_thumbnail_image_file_src}
            alt="Post"
            className={`relative z-10  w-full h-auto rounded-lg   ${ratio >= 0 && ratio < 0.74 ? "object-cover rounded-lg" : "object-contain rounded-lg"}`}
            loading="lazy"
          />
        </div>
      );
    } else {
      return <div>Content Not Found! {post?.media_type}</div>;
    }
  };
  const { showDialogConfirm } = appStore();

  const { token } = useAppSelector((state) => state.auth);

  // const { token } = useAppSelector((state) => state.auth);
  const [loadingSubmit, setloadingSubmit] = useState<boolean>(false);
  const today = new Date();
  const [hideDescription, setHideDescription] = useState<Boolean>(false);
  const [gender, setGender] = useState("All");
  const [age, setAge] = useState([18, 65]);
  const [location, setLocation] = useState("");

  const [days, setDays] = useState(7);

  const [endDate, setEndDate] = useState<any>();
  const [isActive, setIsActive] = useState(campaingsDetail?.inactived === "Yes" ? "No" : "Yes");
  const submitActiveCampaign = async (campaignId: string, value: string) => {
    try {
      const url = `${RouteApi.submitActiveCampaign}token=${token}`;
      const data = {
        campaign_id: campaignId,
        inactived: value === "Yes" ? "No" : "Yes",
      };

      const response = await RequestApi(url, { data });
      if (response.status === "success") {
      }
    } catch (error) {
      AppLog.show({
        message: `[submitActiveCampaign]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const [loadingSubmitDeleteCampaings, setLoadingSubmitDeleteCampaings] = useState<boolean>(false);
  const submitDeleteCampaign = async (campaignId: number) => {
    setLoadingSubmitDeleteCampaings(true);
    try {
      const url = `${RouteApi.submitDeleteCampaign}token=${token}`;
      const data = {
        campaign_id: [campaignId],
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingSubmitDeleteCampaings(false);
        setIsDailogDetailCampaings(false);
        onValueChange({ valuse: "", id: campaignId, name: "delete" });
      } else {
        setLoadingSubmitDeleteCampaings(false);
      }
    } catch (error) {
      setLoadingSubmitDeleteCampaings(false);
      AppLog.show({
        message: `[submitDeleteCampaign]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  useEffect(() => {
    if (campaingsDetail?.budget_amount != null) {
      setBudget(Number(campaingsDetail?.budget_amount));
    } else {
      setBudget(null);
    }
    if (campaingsDetail?.age_from != null) {
      setAge([campaingsDetail?.age_from]);
    }
    if (campaingsDetail?.gender === "") {
      setGender("All");
    } else {
      setGender(campaingsDetail?.gender);
    }
    setIsActive(campaingsDetail?.inactived === "Yes" ? "No" : "Yes");
  }, [campaingsDetail]);

  useEffect(() => {
    const today = new Date();
    const futureDate = new Date();
    futureDate.setDate(today.getDate() + days);
    setEndDate(futureDate);
  }, [days]);

  useEffect(() => {
    if (!endDate) return;
    const dateObj = new Date(endDate); // ensures it's a Date
    if (isNaN(dateObj.getTime())) return;
    const today = new Date();
    const diffTime = dateObj.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    setDays(diffDays);
  }, [endDate]);

  const [budget, setBudget] = useState<number | null>(null);

  const handleBudgetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Allow empty input
    if (value === "") {
      setBudget(null);
      return;
    }
    // Only allow valid numbers
    const parsed = parseFloat(value);
    if (!isNaN(parsed)) {
      setBudget(Math.max(0, parsed));
    }
  };
  const navigate = useNavigate();
  const handleNavigate = (e: any, id: number) => {
    e.stopPropagation();
    navigate(`${RouteUrl.profile}?id=${id}`);
  };
  const statusBgColor =
    campaingsDetail?.status === "In Review"
      ? "bg-yellow-500"
      : campaingsDetail?.status === "Draft"
      ? "bg-gray-300"
      : campaingsDetail?.status === "Approved"
      ? "bg-blue-500"
      : campaingsDetail?.status === "Rejected"
      ? "bg-red-500"
      : campaingsDetail?.status === "Completed"
      ? "bg-green-500"
      : "";
  const [dialogPostReaction, setDialogPostReaction] = useState({
    isOpen: false,
    post: null,
    postReaction: PostReaction.like,
  });
  const onOpenReactionDialog = (post: any, postReaction: PostReaction) => {
    try {
      setDialogPostReaction({
        isOpen: true,
        post: post,
        postReaction,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenReactionDialog]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  return (
    <>
      <Dialog open={isDailogDetailCampaing}>
        <DialogContent isShowBtnXClose={false} className="max-w-full lg:max-w-[1000px]  h-[calc(100vh-80px)] py-2 px-0 flex flex-col ">
          <DialogHeader className="px-4">
            <DialogTitle className=" text-start">Campaings</DialogTitle>
            <DialogDescription className=" text-start">Boosting Your Brand with Engaging Strategies</DialogDescription>
            <div
              className="absolute flex items-center justify-center right-3 top-1 z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px] p-2"
              onClick={() => setIsDailogDetailCampaings(false)}
            >
              <X />
            </div>
          </DialogHeader>

          <ScrollArea className="flex-1 items-center p-5">
            {campaingsDetailLoading ? (
              <>
                <ShimmerCampaingsDetail />
              </>
            ) : (
              <>
                <div className=" lg:grid lg:grid-cols-3 md:grid md:grid-cols-3 pb-1 rounded-lg  mb-4 w-full ">
                  <div className=" lg:col-1 md:col-1">
                    <div className="aspect-[9/16]  relative  ">
                      <div className={`absolute z-40 top-0 left-0  text-white px-2 py-1 rounded-br-md rounded-tl-md mt-0 ${statusBgColor} `}>
                        <span className={`text-sm `}>{campaingsDetail?.status}</span>
                      </div>

                      {postContents(campaingsDetail?.post)}
                    </div>
                  </div>
                  <div className=" lg:col-span-2 md:col-span-2">
                    <div className="flex flex-1 lg:pl-5 md:pl-5 flex-col justify-start">
                      <div className="flex flex-col gap-[7px]">
                        <div className="flex justify-between items-center pe-5 ">
                          <div className="">
                            <p className="lg:text-lg md:text-md line-clamp-2 ">{campaingsDetail?.campaign_type}</p>
                          </div>
                          <div>
                            <SwitchYesNo
                              id="campaign_type_id"
                              value={isActive}
                              onChange={(value) => {
                                setIsActive(value);
                                submitActiveCampaign(campaingsDetail?.campaign_id, value);
                                onValueChange({ valuse: value, id: campaingsDetail?.campaign_id, name: "check_status" });
                              }}
                            />
                          </div>
                        </div>
                        <p className="lg:text-md md:text-sm ">{campaingsDetail?.post?.media_title}</p>
                        {/* ------------------------ */}

                        <div className="flex flex-col justify-between items-center space-x-2 ">
                          <div className="  w-full mt-[30px] pe-2 ">
                            {/* Gender */}
                            <div className="w-full">
                              <label className="block text-md font-medium mb-2">Gender</label>
                              <div className="flex justify-between gap-2">
                                <SelectGroupRadioOptionSingle
                                  datas={["All", "Men", "Women"]}
                                  value={gender}
                                  valueChange={(value) => {
                                    setGender(value);
                                    console.log(value, "gender");
                                  }}
                                  disabled
                                />
                              </div>
                            </div>

                            {/* Age */}
                            <div className="mt-[30px]">
                              <label className="block text-md font-medium my-2">Age</label>
                              <div className="flex items-center justify-between">
                                <span>{age[0]}</span>
                                <input
                                  disabled
                                  type="range"
                                  min={18}
                                  max={65}
                                  value={age[0]}
                                  onChange={(e) => setAge([parseInt(e.target.value), age[1]])}
                                  className="mx-2 w-full"
                                />
                                <span>65+</span>
                              </div>
                              <p className="text-[15px]  mt-1 dark:bg-gray-700 bg-gray-200 px-3 py-2 rounded-md ">
                                When targeting audiences based on factors like gender or interests, only individuals over the age of 18 can be included.
                              </p>
                            </div>

                            {/* Locations */}
                            <div className="mt-[30px]">
                              <label className="block font-semibold mb-2">Locations</label>

                              <TextInput disabled className="py-[30px]" value={location} onChange={(e) => setLocation(e.target.value)} placeholder="Type to add more locations" />
                              {location && (
                                <div className="mt-2 inline-flex items-center bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">
                                  {location}
                                  <button onClick={() => setLocation("")} className="ml-2 text-blue-700 hover:text-red-600">
                                    x
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="w-full mt-[30px] pe-2">
                          {/* Duration */}
                          <div>
                            <label className="block font-semibold mb-2">Duration</label>
                            <div className="grid grid-cols-2  gap-4">
                              <div className="flex items-center gap-2 border rounded px-2  py-[15px]">
                                <div className="flex justify-between items-center w-full">
                                  <div className="flex flex-col ps-3">
                                    <span>
                                      {days} {days === 1 ? "Day" : "Days"}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-5">
                                    <button
                                      disabled
                                      className=" w-8 h-8 cursor-not-allowed rounded-full dark:text-white border border-1 dark:border-white border-black flex items-center justify-center"
                                      onClick={() => setDays((prev) => Math.max(1, prev - 1))}
                                    >
                                      <Minus />
                                    </button>
                                    <button
                                      disabled
                                      onClick={() => setDays((prev) => prev + 1)}
                                      className=" w-8 h-8 cursor-not-allowed rounded-full dark:text-white border border-1 dark:border-white border-black flex items-center justify-center"
                                    >
                                      <Plus />
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="">
                                <DatePicker
                                  className="h-10"
                                  onChange={(value: any) => {
                                    setEndDate(value);
                                  }}
                                  value={endDate}
                                  disabled={true}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Daily Budget */}
                          <div className="mt-[30px] mb-[80px]">
                            <label className="block font-semibold mb-2">Daily budget</label>
                            <div className=" border-l-4 border-blue-400 p-3 text-sm rounded">
                              <strong>Introducing daily budget for boosting</strong>
                              <br />
                              Get more control over your ad spend by setting the average amount you want to spend each day.
                            </div>

                            <div className="flex items-center justify-center text-blue-600 text-3xl font-semibold mt-2">
                              $ {budget ? budget : "0.00"}
                              <NumberInput disabled className="ml-3 text-base w-20 border px-2 py-1 rounded" value={budget ?? 0} onChange={handleBudgetChange} />
                            </div>
                            {/* <input type="number" min={1} step={0.01} value={budget} onChange={handleBudgetChange} className="ml-3 text-base w-20 border px-2 py-1 rounded" /> */}
                            <input disabled type="range" min={0} max={500} value={budget ?? 0} onChange={(e) => setBudget(parseFloat(e.target.value))} className="w-full mt-4" />
                            {/* <input type="range" min={100} className="w-full mt-4" />
                             */}
                            <div className="flex justify-between text-sm text-gray-500">
                              <span>$1.00</span>
                              <span>$500.00</span>
                            </div>
                          </div>
                        </div>

                        {/* ------------------------- */}

                        <table className="w-full table-auto text-sm text-left border-collapse border border-gray-300">
                          <thead>
                            <tr className="text-center">
                              <th className="font-medium border border-gray-300 px-4 py-2 w-[25%]">Impressions</th>
                              <th className="font-medium border border-gray-300 px-4 py-2 w-[25%]">Results</th>
                              <th className="font-medium border border-gray-300 px-4 py-2 w-[25%]">Cost per result</th>
                              <th className="font-medium border border-gray-300 px-4 py-2 w-[25%]">Spending amount</th>
                              {/* <th className="font-medium border border-gray-300 px-4 py-2">Reach</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            <tr className=" text-end">
                              <td className="border border-gray-300 px-4 py-2">{campaingsDetail?.impression_count}</td>
                              <td className="border border-gray-300 px-4 py-2">{campaingsDetail?.result_count}</td>
                              <td className="border border-gray-300 px-4 py-2">${Number(campaingsDetail?.cost_per_result).toFixed(2)}</td>
                              <td className="border border-gray-300 px-4 py-2">${Number(campaingsDetail?.spending_amount).toFixed(2)}</td>
                              {/* <td className="border border-gray-300 px-4 py-2">{campaingsDetail?.reach_count}</td> */}
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div className="flex flex-col justify-start w-full gap-2 mt-3 ">
                        <div className=" font-medium text-muted-foreground pt-1 flex flex-col  justify-start h-[60px]">
                          <span className="text-sm ">
                            <span
                              className=" cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                onOpenReactionDialog(campaingsDetail?.post, PostReaction.comment);
                              }}
                            >
                              {campaingsDetail?.post?.comment_count} Comment
                            </span>
                          </span>
                          <div className="flex justify-start -space-x-4 rtl:space-x-reverse">
                            {campaingsDetail?.post?.comment_users?.map((item: any, index: any) => {
                              return (
                                <div key={index}>
                                  <img
                                    src={item?.picture ? item?.picture : noneProfile}
                                    alt="User avatar"
                                    className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800 cursor-pointer"
                                    onClick={(e) => {
                                      handleNavigate(e, item.id);
                                    }}
                                  />
                                </div>
                              );
                            })}
                            {campaingsDetail?.post?.comment_count > 3 ? (
                              <p className="flex items-center justify-center w-8 h-8 text-[10px] font-medium text-white bg-gray-700 border-2 border-white rounded-full hover:bg-gray-600 dark:border-gray-800">
                                +{Service.abbreviateNumber(campaingsDetail?.comment_count - 3)}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                        <div className=" font-medium text-muted-foreground pt-1 flex flex-col justify-start h-[60px]">
                          <span className="text-sm">
                            <span
                              className=" cursor-pointer hover:border-1 border-gray-500"
                              onClick={(e) => {
                                e.stopPropagation();
                                onOpenReactionDialog(campaingsDetail?.post, PostReaction.share);
                              }}
                            >
                              {campaingsDetail?.post?.reaction_share_count} Shared
                            </span>
                          </span>
                          <div className="flex justify-start -space-x-4 rtl:space-x-reverse ">
                            {campaingsDetail?.post?.share_users?.map((item: any, index: any) => {
                              return (
                                <div key={index}>
                                  <img
                                    onClick={(e) => {
                                      handleNavigate(e, item.id);
                                    }}
                                    src={item?.picture ? item?.picture : noneProfile}
                                    alt="User avatar"
                                    className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800 cursor-pointer"
                                  />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        <div className=" font-medium text-muted-foreground pt-1 flex flex-col justify-start h-[60px]">
                          <span className="text-sm">
                            <span
                              className=" cursor-pointer hover:border-1 border-gray-500"
                              onClick={(e) => {
                                e.stopPropagation();
                                onOpenReactionDialog(campaingsDetail?.post, PostReaction.like);
                              }}
                            >
                              {campaingsDetail?.post?.reaction_like_count} Likes
                            </span>
                          </span>
                          <div className="flex justify-start -space-x-4 rtl:space-x-reverse">
                            {campaingsDetail?.post?.like_users?.map((item: any, index: any) => {
                              return (
                                <div key={index}>
                                  <img
                                    onClick={(e) => {
                                      handleNavigate(e, item.id);
                                    }}
                                    src={item?.picture ? item?.picture : noneProfile}
                                    alt="User avatar"
                                    className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800 cursor-pointer"
                                  />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        <div className=" font-medium text-muted-foreground pt-1 flex flex-col  justify-start h-[80px]">
                          <span className="text-sm">
                            <span
                              className=" cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                onOpenReactionDialog(campaingsDetail?.post, PostReaction.view);
                              }}
                            >
                              {campaingsDetail?.post?.reach_count} Reachs
                            </span>
                          </span>
                          <div className="flex justify-start -space-x-4 rtl:space-x-reverse">
                            {campaingsDetail?.post?.reach_users?.map((item: any, index: any) => {
                              return (
                                <div key={index}>
                                  <img
                                    onClick={(e) => {
                                      handleNavigate(e, item.id);
                                    }}
                                    src={item?.picture ? item?.picture : noneProfile}
                                    alt="User avatar"
                                    className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800 cursor-pointer"
                                  />
                                </div>
                              );
                            })}
                            {campaingsDetail?.reach_count > 3 ? (
                              <p className="flex items-center justify-center w-8 h-8 text-xs font-medium text-white bg-gray-700 border-2 border-white rounded-full hover:bg-gray-600 dark:border-gray-800">
                                +{Service.abbreviateNumber(campaingsDetail?.reach_count - 3)}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </ScrollArea>
          <div className="flex justify-between gap-3 pr-[20px] items-center px-4 fixed bottom-[10px] z-50 left-0 w-full">
            <button
              onClick={() =>
                showDialogConfirm({
                  titileButtonSubmit: "Yes, Delete",
                  titileButtonCancel: "No, Cancel",
                  title: "Delete",
                  message: "Do you want to delete ?",
                  onSubmit() {
                    // onSubmitDeleteProdcuts();
                    submitDeleteCampaign(campaingsDetail?.campaign_id);
                  },
                })
              }
              className="w-full mt-6  bg-red-500 text-white lg:text-lg md:text-md text-sm py-2 rounded-lg flex items-center justify-center outline-none focus:border-none"
            >
              {/* {loadingSubmitDeleteCampaings ? <Loader className="animate-spin" /> : "Delete"} */}
              {loadingSubmitDeleteCampaings ? <Loader className=" animate-spin" /> : "Delete"}
            </button>
            <button
              disabled
              onClick={() => {
                // onSubmitUpdateProdcuts();
              }}
              className="w-full mt-6 flex items-center justify-center lg:text-lg md:text-md text-sm py-2 rounded-lg 
              text-white dark:text-white
             bg-gray-300 dark:bg-slate-500 disabled:text-gray-500 disabled:cursor-not-allowed"
            >
              {loadingSubmit ? <Loader className="animate-spin" /> : "Save"}
            </button>
          </div>
        </DialogContent>
        {dialogPostReaction.isOpen && (
          <DialogPostReaction
            post={dialogPostReaction.post}
            isDialogOpen={dialogPostReaction.isOpen}
            postReaction={dialogPostReaction.postReaction}
            setIsDialogOpen={(isOpen) => setDialogPostReaction({ ...dialogPostReaction, isOpen })}
          />
        )}
      </Dialog>
    </>
  );
}
